import { gql } from '@apollo/client'

const DELETE_INSURANCE_COMPANY = gql`
    mutation DELETE_INSURANCE_COMPANY($insuranceCompany: ID!) {
        deleteInsuranceCompany(insuranceCompany: $insuranceCompany) {
            id
        }
    }
`

export default DELETE_INSURANCE_COMPANY
